import { gql } from '@apollo/client';

export const GET_PAYMENT_CSV = gql`
  query GetPaymentCsv($input: PaymentCsvInput) {
  getPaymentCsv(input: $input) {
    csv
  }
}
`;
